import React from "react";


const PIPSTwContent = () => {
    return (
        <>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>發行日期：民國108年01月01日</div>
                <div>最後修訂日期：民國114年12月29日</div>
                <div className={"pt-5"}>本告知函乃依據個人資料保護法第八條之規定，於蒐集您的個人資料時進行法定告知義務</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">一、蒐集之機關名稱：</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>財團法人國家實驗研究院科技政策研究與資訊中心（以下簡稱本中心）</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">二、蒐集之目的：</div>
            <div className="text-[20px] leading-[40px] mb-[45px] space-y-[45px]">
                <div>
                  本中心蒐集您個人資料的目的在於進行本中心各項科技研究活動、科技人才管理、會員、客戶管理、行銷、內部各項統計調查與分析與本中心依法設立之法定義務作業使用。其法定之特定目的為：

                  <ul className="list-disc list-inside ps-5">
                    <li>040 行銷(包含金控共同行銷業務)</li>
                    <li>075 科技行政</li>
                    <li>078 計畫、管制考核與其他研考管理</li>
                    <li>090 消費者、客戶管理與服務</li>
                    <li>129 會計與相關服務</li>
                    <li>130 會議管理</li>
                    <li>172 其他公共部門（包括行政法人、政府捐助財團法人及其他公法人）執行相關業務</li>
                    <li>181 其他經營合於營業登記項目或組織章程所定之業務</li>
                  </ul>
                </div>

            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">三、蒐集個人資料類別：</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <ul className="list-decimal list-inside">
                    <li>辨識個人者：如姓名、地址、電話、電子郵件等個人資料。</li>
                    <li>辨識財務者：如帳號。</li>
                    <li>政府資料中之辨識者：如身分證字號或護照號碼(外國人)。</li>
                    <li>個人描述：如性別、國籍、出生年月日、著作。</li>
                    <li>當您使用本組織網站，我們將使用 cookies 進行管理及記錄活動紀錄。包括記錄您 IP 位址、瀏覽器種類及時間等軌跡資料。</li>
                    <li>以上類別屬於個人資料保護法蒐集類別之：

                      <ul className="list-disc list-inside ps-5">
                        <li>C001/辨識個人者</li>
                        <li>C002/辨識財務者</li>
                        <li>C003/政府資料中之辨識者</li>
                        <li>C011/個人描述</li>
                        <li>C051/學校紀錄</li>
                        <li>C052/資格或技術</li>
                        <li>C056/著作</li>
                        <li>C061/現行之受僱情形</li>
                      </ul>
                    </li>
                </ul>
            </div>


            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">四、所蒐集個人資料利用期間、地區對象及方式：</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <ul className="list-decimal list-inside">
                    <li>個人資料之利用期間為本組織或業務之存續期間，利用地區不限。</li>
                    <li>利用方式：</li>
                        <ul className="list-disc list-inside ps-5">
                            <li>電子郵件：用於聯絡使用。</li>
                            <li>公務電話：作為本單位相關業聯繫使用。</li>
                            <li>行動電話：除業務聯繫外，作為傳送訊息使用。</li>
                        </ul>
                    <li>利用對象：本中心、本中心受委託及委託之對象。</li>
                    </ul>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">五、個人資料之權利及權益：</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>您依法得行使個人資料保護法第三條之個人權利，權利之行使方式請電洽或以電子郵件詢問本中心之服務人員電子郵件：<a
                    className="text-blue-700 underline px-2"
                    href="mailto:privacy.stpi@niar.org.tw">privacy.stpi@niar.org.tw</a>。</div>

              <div>
                您得依法請求行使個人資料保護法第三條所規範之個人權利，包含：

                <ul className="list-decimal list-inside ps-5">
                  <li>查詢或請求閱覽。</li>
                  <li>請求製給複製本。</li>
                  <li>請求補充或更正。</li>
                  <li>請求停止蒐集、處理或利用。</li>
                  <li>請求刪除。</li>
                </ul>
              </div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">六、線上系統之「*」為必填資料如未寫，將導致本中心無法繼續提供服務。六、線上系統之「*」為必填資料如未寫，將導致本中心無法繼續提供服務。本中心於蒐集您的個人
              資料時，如有欄位標示為選擇性填寫，當您選擇不提供該個人資料時將不造成任何之權利影響。</div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">七、本中心保有修訂本告知函之權利，並於修正後透過您所提供的聯絡方式通知或於網站上公告，如您未提出異議或繼續使用本中心相關服務，表示您已同意本中心所更改之內容。</div>
            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">八、當事人如無法提供以上作業需求個人資料，本中心將無法提供相關服務或作業辦理。</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>本人已詳閱以上告知內容，並同意以上之告知內容。</div>
            </div>
        </>
    );
}

export default PIPSTwContent;